import {Component} from 'react';
import styles from './portal-identity-tile.component.module.scss';

interface Props {
    email: string;
    planLabel?: string;
    credits?: number;
}

function initialsFor(email: string): string {
    if (!email) return '—';
    const cleaned = email.replace(/[^a-zA-Z0-9]/g, '');
    if (!cleaned) return '—';
    return cleaned.slice(0, 2).toUpperCase();
}

/**
 * Identity tile at the top of the portal sidebar — avatar (initials
 * from email), email line, plan badge + credit balance. Replaces the
 * plain "Portal / email@..." header in PortalLayout.
 */
export default class PortalIdentityTile extends Component<Props> {
    render() {
        const {email, planLabel, credits} = this.props;
        const initials = initialsFor(email);
        const hasMeta = !!planLabel || credits !== undefined;
        return (
            <div className={styles.tile}>
                <div className={styles.avatar}>{initials}</div>
                <div className={styles.meta}>
                    <div className={styles.email}>{email}</div>
                    {hasMeta && (
                        <div className={styles.sub}>
                            {planLabel && <span className={styles.planPill}>{planLabel}</span>}
                            {credits !== undefined && (
                                <>
                                    <span>·</span>
                                    <span>{credits.toLocaleString()} credits</span>
                                </>
                            )}
                        </div>
                    )}
                </div>
            </div>
        );
    }
}
